import request from '@/utils/request'
import request2 from '@/utils/request2'

//new api
export function login_company(params) {
    return request({
        url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_login_authorize_company',
        method: 'post',
        params
    })
}

export function login_branch(params) {
    return request({
        url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_login_authorize_branch',
        method: 'post',
        params
    })
}







/* end new */


// 登录
export function login(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_login',
      method: 'get',
      params
    })
}



// 注册
export function register(params) {
    return request({
      //url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_reg',
      method: 'get',
      params
    })
}

// 修改资料
export function changeUserinfo(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_updateqy',
    method: 'get',
    params
  })
}

// 获取用户信息
export function getUserinfo(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_userinfo',
    method: 'get',
    params
  })
}

// 获取facebook用户信息
export function getFacebookUserinfo(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_facebook_info',
    method: 'get',
    params
  })
}

//修改密码

export function updatePassword(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_updatepwd',
    method: 'get',
    params
  })
}

//新增範本
export function addTemplate(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_tmp_insert',
    method: 'get',
    params
  })
}

//新增範本
export function addAutoTemplate(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_autotmp_insert',
    method: 'get',
    params
  })
}

//新增huodong
export function addHuoDong(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_huodong_insert',
    method: 'get',
    params
  })
}

//新增排队座位
export function addPaiduiSet(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_set_paidui',
    method: 'get',
    params
  })
}

//修改通用设置
export function api_tongyong_edit(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_tongyong_edit',
    method: 'get',
    params
  })
}

//新增代发列表
export function addDaifa(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_daifa_insert',
    method: 'get',
    params
  })
}

//叫号https://w7.khshop.online/app/index.php?i=1&c=entry&m=qicheng_messenger&do=jh_paidui&id=2
export function jh_paidui(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=jh_paidui',
    method: 'get',
    params
  })
}

//新增任务列表
export function addRenwu(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_sendrw_insert',
    method: 'get',
    params
  })
}
export function addRenwu_excel(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_sendrw_insert_fromexcel',
    method: 'get',
    params
  })
}
//新增资源到列表
export function addRenwu_zy(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_ziyuan_into',
    method: 'get',
    params
  })
}

//通用列表
export function tongyong(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_tongyong',
    method: 'get',
    params
  })
}

//统计
export function tongji(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_tongji',
    method: 'get',
    params
  })
}

//读取数据库结构
export function sjk(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=sjk',
    method: 'get',
    params
  })
}

//读取数据库结构
export function funk(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger',
    method: 'get',
    params
  })
}

export function imageUpload(data) {
  return request( {
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_img_down',
    method:'POST',
    headers: {'content-type': 'multipart/form-data'},
    data
  });
}

// 會員數量
export function getDaifalistNum(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_user_daifalist',
    method: 'get',
    params
  })
}

// 本月新增會員
export function getNewDaifalistNum(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_user_newdaifalist',
    method: 'get',
    params
  })
}

// 發出信息數量
export function getSenderlistNum(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_user_sendlist',
    method: 'get',
    params
  })
}

// 發出活動訂單
export function getHuodongNum(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_num_huodong_yhq',
    method: 'get',
    params
  })
}

// 會員群組會員列表
export function getDaifalistByGroup(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_user_daifalistbygroup',
    method: 'get',
    params
  })
}

// 會員群組
export function getDaifafile(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_user_daifafile3',
    method: 'get',
    params
  })
}

// 
export function getShopProduct(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_shop_product',
    method: 'get',
    params
  })
}

export function addShopProduct(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_shop_product',
    method: 'get',
    params
  })
}

//
export function getShopOrder(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_shop_order',
    method: 'get',
    params
  })
}

export function getShopOrder_2(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_shop_order_2',
      method: 'get',
      params
    })
}

export function exportShopOrder_2(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_shop_order_2_csv',
      method: 'get',
      params
    })
}

// 顧客信息
export function getReceiveHistory(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_receivehistory',
    method: 'get',
    params
  })
}

export function getReceiveHistory_2(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_receivehistory_2',
      method: 'get',
      params
    })
}

export function exportReceiveHistory_2(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_receivehistory_2_csv',
      method: 'get',
      params
    })
}

export function getReceiveHistory_luckydraw(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_receivehistory_luckydraw',
    method: 'get',
    params
  })
}

export function getChatHistory(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_chathistory',
    method: 'get',
    params
  })
}

export function getUsersReport(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_report_users',
    method: 'get',
    params
  })
}

export function getUserList(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_userlist4',
    method: 'get',
    params
  })
}

export function exportUserList(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_userlist4_csv',
      method: 'get',
      params
    })
  }


export function getMetaTemplate(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_metatemplate',
    method: 'get',
    params
  })
}

export function addMetaTemplate(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_metatemplate',
    method: 'get',
    params
  })
}

export function getStore(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_store',
    method: 'get',
    params
  })
}

export function addStore(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_store',
    method: 'get',
    params
  })
}

export function getStoreData(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_store_data',
    method: 'get',
    params
  })
}

export function getFPSHistory(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_settlement_fpsgpp_history',
    method: 'get',
    params
  })
}

export function getFPSHistory_sim(params) {
  return request({
    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_settlement_fpsgpp_history_sim',
    method: 'get',
    params
  })
}

export function getStoreauthorizelist(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_getstoreauthorizelist',
      method: 'get',
      params
    })
}

export function addStoreauthorizelist(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_storeauthorizelist',
      method: 'get',
      params
    })
}

export function editStoreauthorizelist(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_storeauthorizelist',
      method: 'get',
      params
    })
}

export function deleteStoreauthorizelist(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_storeauthorizelist',
      method: 'get',
      params
    })
}

export function getinfoStoreauthorizelist(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_storeauthorizelist',
      method: 'get',
      params
    })
}

export function addStoreposlist(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_storeposlist',
      method: 'get',
      params
    })
}

export function getStoreposlist(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_storeposlist',
      method: 'get',
      params
    })
}

export function getCouponUsage(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_getcoupon_usage',
      method: 'get',
      params
    })
}

export function getBroadcastRecord(params) {
    return request({
      url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_getbroadcast_record',
      method: 'get',
      params
    })
}

export function getMetaMediabyId(mediaid) {
    return request2({
      url: 'https://graph.facebook.com/v22.0/' + mediaid,
      method: 'get',
    })
}

export function downloadMetaMedia(url) {
    return request2({
      url: url,
      method: 'get',
    })
}